import { render, staticRenderFns } from "./seed.vue?vue&type=template&id=dd50c000&scoped=true&"
import script from "./seed.vue?vue&type=script&lang=js&"
export * from "./seed.vue?vue&type=script&lang=js&"
import style1 from "./seed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd50c000",
  null
  
)

export default component.exports